module.exports = __webpack_public_path__ + "static/selectmark-multi-do-166d40b209c59d1fdad09f666f19a621.png";